var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.357 41.928c11.677 0 21.143-9.178 21.143-20.5S33.034.928 21.357.928C9.681.928.215 10.106.215 21.428s9.466 20.5 21.142 20.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF460F",
    stroke: "#000",
    strokeWidth: 2,
    d: "M25.745 13.052v1.092h-.625c-.998 0-1.821.297-2.384.907-.548.594-.716 1.34-.716 1.977v3.266h3.393l-.243 1.485h-3.15V30.2h-2.015v-8.428h-3.27v-1.484h3.27v-3.66c0-1.29.405-2.178 1.013-2.748.617-.578 1.564-.942 2.849-.942.65 0 1.331.055 1.857.112z"
  })));
};
export default SvgFacebook;